import React from 'react'
import { getFormattedAmountWithDenomination } from '../../utils/TextUtils'

// The blue ice header panel + its labels (Valor R$ / Créditos / Pago /
// Aposta Total / Aposta Linha) are baked into the background image.
// This component only overlays the dynamic values on top, plus the
// ACUMULADO title + jackpot value over the empty centre bump.
//
// Values are derived exactly like Halloween_20's header:
//   Valor R$      -> the money balance
//   Créditos      -> that balance in credits (amount / denomination)
//   Pago          -> winnings (credits)
//   Aposta Linha  -> the bet per line, in credits
//   Aposta Total  -> bet per line x active lines
function IceHeader({
    walletBalance = 0,
    denomination = 0.01,
    winnings = 0,
    betMultiplier = 0,
    selectedNumber = 1,
    acumulado = 0,
}) {
    const money = (n) => Number(n || 0).toFixed(2).replace('.', '.')
    // The ACUMULADO value carries two decimals — 16000 shows as 16000.00.
    const paid = (n) => Number(n || 0).toFixed(2)
    // Pago is left blank when there is nothing to pay. The span itself stays:
    // each left value is pinned to its label by nth-child, so dropping it would
    // shift nothing today but would break if that ever goes back to a flex column.
    // Pago itself shows a whole number with no trailing .0 (16000, not 16000.0).
    const pago = Number(winnings) > 0 ? String(Math.round(Number(winnings))) : ''
    const betPerLine = getFormattedAmountWithDenomination(betMultiplier, denomination)

    return (
        <div className='ice-header'>
            <div className='ice-hd-left'>
                <span className='ice-hd-val'>{money(walletBalance)}</span>
                <span className='ice-hd-val'>{getFormattedAmountWithDenomination(walletBalance, denomination)}</span>
                <span className='ice-hd-val'>{pago}</span>
            </div>

            <div className='ice-hd-center'>
                <span className='ice-hd-acum-title'>ACUMULADO</span>
                <div className='ice-hd-acum-val'><span className='ice-hd-acum-rs'>R$ </span><span><b>{paid(acumulado)}</b></span></div>
            </div>

            <div className='ice-hd-right'>
                <span className='ice-hd-val'> {getFormattedAmountWithDenomination(betMultiplier, denomination) * selectedNumber}</span>
                <span className='ice-hd-val' style={{ paddingTop: "3.5vh" }}> {getFormattedAmountWithDenomination(betMultiplier, denomination)}</span>
            </div>
        </div>
    )
}

export default IceHeader
